<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/User/pixinvent
    ========================================================================================== -->
<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Bem-vindo de volta, faça login na sua conta.</p>
                </div>
                <div v-on:keyup.enter="signin">
                  <vs-input name="email" icon-no-border icon-after icon="icon icon-user" icon-pack="feather" v-model="user.email" class="w-full" />
                  <vs-input icon-no-border @icon-click="changePasswordView()" icon-after :icon="passwordInput.classIcon" icon-pack="feather" :type="passwordInput.type" v-model="user.password" class="w-full mt-6" />
                  <br>
                  <vs-button class="float-right" @click="signin">Login</vs-button>
                  <vs-divider>Regnaparts {{this.year}}</vs-divider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { baseApiUrl, userKey } from "@/global";
import axios from 'axios'
import helpers from '@/helpers';
export default {
  data() {
    return {
      user: {},
      passwordInput: {
        type: "password",
        classIcon: "icon icon-eye",
      },
      checkbox_remember_me: false,
      year: '',
    }
  },
  methods: {
    changePasswordView(){
      if (this.passwordInput.type == "password"){
        this.passwordInput.type = "text"
        this.passwordInput.classIcon = "icon icon-eye-off"
      }
      else{
        this.passwordInput.type = "password"
        this.passwordInput.classIcon = "icon icon-eye"
      }

    },
    async signin() {
      try {
        // Loading
        this.$vs.loading()
        let res = await axios.post(`${baseApiUrl}/signin`, this.user);
        this.$store.commit('SET_USER_INFO', res.data)
        localStorage.setItem(userKey, JSON.stringify(res.data));
        this.$vs.loading.close()
        this.$router.push({ path: "/" });
      } catch (error) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: error.response.data,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async showYear() {
      this.year = helpers.dateHelper.getYear()
    },
  },
  created() {
    this.showYear()
  }
}

</script>
<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}

.icon-eye, .icon-eye-off {
  cursor: pointer;
}

</style>
